import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ways-to-fund',
  template: require('./ways-to-fund.component.html')
})

export class WaysToFundComponent {
  constructor(route: ActivatedRoute) {
    this.accountType = {
      stepTitle: 'Ways to fund your account'
    };
  }
}
